import { createUseStyles } from 'react-jss';
export const useLiveChatBackdropStyles = createUseStyles({
    'livechat-back-drop': {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999999999,
        cursor: 'move',
    },
});
